import { render, staticRenderFns } from "./BookGeneratorWorking.vue?vue&type=template&id=2d536ffe&scoped=true&"
import script from "./BookGeneratorWorking.vue?vue&type=script&lang=js&"
export * from "./BookGeneratorWorking.vue?vue&type=script&lang=js&"
import style0 from "./BookGeneratorWorking.vue?vue&type=style&index=0&id=2d536ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d536ffe",
  null
  
)

export default component.exports